module.exports = __webpack_public_path__ + "img/6012bec990e62306dd96036294b926b6.png";